var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"hotkey",rawName:"v-hotkey",value:(_vm.keymap),expression:"keymap"}],staticClass:"die-wrapper",class:[_vm.translateToCenter ? 'rolling' : null]},[_c('div',{class:[
      'die-inner-wrapper',
      _vm.selectedClass ? 'selected' : null,
      _vm.lastSelection ? 'last-selection' : null,
      _vm.hidden ? 'hidden' : null
    ],on:{"click":function($event){return _vm.select()}}},[_c('div',{class:[
        'die', 
        this.number ? 'd' + this.number : 'dnull'
      ],style:({
        transform: 'rotate(' + this.rotation + 'deg)'
      })})])])}
var staticRenderFns = []

export { render, staticRenderFns }